import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.activityList.loading;
export const selectErrorMessage = (state: RootState) =>
  state.activityList.error;
export const activityListDataResponse = (state: RootState) =>
  state.activityList.activitySchoolResponse;
